import React from "react";
import { withTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';

const NewMailingAddressSummary = ({ t, i18n, setIsError, isCivic }) => {

    const { mailingAddressSame } = useSelector((state) => state.app.newAddress);
    const { apartment, city, postalCode, streetAddress } = useSelector((state) => state.app.newAddress.mailingAddress);

    const { homeAddress, mailingAddress } = useSelector((state) => state.app.addressesToChange);


    if (!mailingAddress) {
        return null;
    }

    if (homeAddress && mailingAddressSame) {
        return (
            <><div className="row" style={{ display: 'flex', flexGrow: 1 }}>
                <div className="col-xs-6">{isCivic ? t('new_address.same_as_civic_address') : t('new_address.same_as_home_address')}</div>
            </div>
                <hr /></>

            // <div className="row" style={{ display: 'flex', flexGrow: 1, }}>
            //     <div className="col" style={{ flexGrow: 1 }}>{isCivic ? t('new_address.same_as_civic_address') : t('new_address.same_as_home_address')}</div>
            // </div>
        )
    }

    return (
        <>
            <div className="row" style={{ display: 'flex', flexGrow: 1 }}>
                <div className="col-xs-6"><strong>{t('current_address.street_address')}</strong></div>
                <div className="col-xs-6">{streetAddress}</div>
            </div>

            <hr />


            <div className="row" style={{ display: 'flex', flexGrow: 1 }}>
                <div className="col-xs-6"><strong>{t('current_address.apartment')}</strong></div>
                <div className="col-xs-6">{apartment ? `${apartment}` : null}</div>
            </div>

            <hr />


            <div className="row" style={{ display: 'flex', flexGrow: 1 }}>
                <div className="col-xs-6"><strong>{t('current_address.city')}</strong></div>
                <div className="col-xs-6" style={{ lineBreak: "anywhere" }}>{city}</div>
            </div>

            <hr />

            <div className="row" style={{ display: 'flex', flexGrow: 1 }}>
                <div className="col-xs-6"><strong>{t('current_address.postal_code')}</strong></div>
                <div className="col-xs-6" style={{ lineBreak: "anywhere" }}>{postalCode.toUpperCase()}</div>
            </div>

            <hr />

            {/* <div className="row" style={{ display: 'flex', flexGrow: 1, }}>
                <div className="col" style={{ flexGrow: 1 }}>{streetAddress} {apartment ? `${t('review_summary.unit')} ${apartment}` : ''}</div>
            </div>
            <div className="row" style={{ display: 'flex', flexGrow: 1, }}>
                <div className="col" style={{ flexGrow: 1 }}>{city}, {postalCode.toUpperCase()}</div>
            </div> */}
        </>
    )
}

export default withTranslation('common')(NewMailingAddressSummary)
